import {
  Directive,
  HostListener
} from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[ngModel][parNumberOnly]'
})

export class NumberOnlyDirective {
  private value: any;
  private numberRegex = /[^0-9]/g;

  constructor(public model: NgModel) { }

  @HostListener('input', ['$event'])
  onInputChange(event) {
    this.value = event.target.value.replace(this.numberRegex, '');
    this.model.valueAccessor.writeValue(this.value);
    this.model.viewToModelUpdate(this.value);
  }
}
